module.exports = __webpack_public_path__ + "92df65f36e571c445277121de6f918ef.jpg";